import type { BlockExportMapping } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { Root } from "@/react/components/shared/BuilderUI/DefaultBlocks/Root";
import { FormButtonBlock } from "./FormButtonBlock";
import { blockToElement as FormButtonBlockToElement } from "./FormButtonBlock/blockToElement";
import { elementToBlock as FormButtonElementToBlock } from "./FormButtonBlock/elementToBlock";
import { FormContactEmailBlock } from "./FormContactEmailBlock";
import { blockToElement as FormContactEmailBlockToElement } from "./FormContactEmailBlock/blockToElement";
import { elementToBlock as FormContactEmailElementToBlock } from "./FormContactEmailBlock/elementToBlock";
import { FormContactNameBlock } from "./FormContactNameBlock";
import { blockToElement as FormContactNameBlockToElement } from "./FormContactNameBlock/blockToElement";
import { elementToBlock as FormContactNameElementToBlock } from "./FormContactNameBlock/elementToBlock";
import { FormHeadingBlock } from "./FormHeadingBlock";
import { blockToElement as FormHeadingBlockToElement } from "./FormHeadingBlock/blockToElement";
import { elementToBlock as FormHeadingElementToBlock } from "./FormHeadingBlock/elementToBlock";
import { FormParagraphBlock } from "./FormParagraphBlock";
import { blockToElement as FormParagraphBlockToElement } from "./FormParagraphBlock/blockToElement";
import { elementToBlock as FormParagraphElementToBlock } from "./FormParagraphBlock/elementToBlock";
import { FormStackBlock } from "./FormStackBlock";
import { blockToElement as FormStackBlockToElement } from "./FormStackBlock/blockToElement";
import { elementToBlock as FormStackElementToBlock } from "./FormStackBlock/elementToBlock";

export const formBlocks: BlockExportMapping = {
  root: Root,
  FormContactEmailBlock,
  FormContactNameBlock,
  FormHeadingBlock,
  FormParagraphBlock,
  FormButtonBlock,
  FormStackBlock,
};

// Registry of block conversion functions
export const blockConverters = {
  FormContactNameBlock: {
    elementToBlock: FormContactNameElementToBlock,
    blockToElement: FormContactNameBlockToElement,
  },
  FormContactEmailBlock: {
    elementToBlock: FormContactEmailElementToBlock,
    blockToElement: FormContactEmailBlockToElement,
  },
  FormHeadingBlock: {
    elementToBlock: FormHeadingElementToBlock,
    blockToElement: FormHeadingBlockToElement,
  },
  FormParagraphBlock: {
    elementToBlock: FormParagraphElementToBlock,
    blockToElement: FormParagraphBlockToElement,
  },
  FormButtonBlock: {
    elementToBlock: FormButtonElementToBlock,
    blockToElement: FormButtonBlockToElement,
  },
  FormStackBlock: {
    elementToBlock: FormStackElementToBlock,
    blockToElement: FormStackBlockToElement,
  },
};
